<template>
    <v-navigation-drawer v-model="drawer" theme="dark" location="right" style="z-index: 1200" temporary>
        <v-list density="compact" class="mt-5 pt-5 mb-2">
            <template v-if="!['authorization', 'b2b-auth', 'restore-password'].includes($route.name as string)">
                <v-list-item class="py-0">
                    <account-menu @auth="drawer = false" />
                </v-list-item>
            </template>
            <v-list-item v-else class="py-0">
                <language-switcher class="mx-0 px-0" />
            </v-list-item>
        </v-list>
        <navigation-drawer-mobile-menu
            v-if="!['authorization', 'b2b-auth', 'restore-password'].includes($route.name as string)"
        />
        <contacts-block class="pa-4" />
    </v-navigation-drawer>
</template>

<script lang="ts">
    import {Component, VModel, Vue} from 'vue-facing-decorator'
    import AccountMenu from '~src/components/account/accountMenu.src'
    import CurrencySwitcher from '~/components/CurrencySwitcher.vue'
    import LanguageSwitcher from '~/components/LanguageSwitcher.vue'
    import NavigationDrawerMobileMenu from '@/components/snippets/NavigationDrawerMobileMenu.vue'
    import ContactsBlock from '@/components/snippets/ContactsBlock.vue'

    @Component({
        components: {
            ContactsBlock,
            NavigationDrawerMobileMenu,
            AccountMenu,
            LanguageSwitcher,
            CurrencySwitcher,
        },
    })
    export class NavigationDrawerMobile extends Vue {
        @VModel({default: false}) drawer
    }

    export default NavigationDrawerMobile
</script>
